import { orderApprovalDetailsActionButtonsStyles } from "@insite/content-library/Widgets/OrderApprovalDetails/OrderApprovalDetailsActionButtons";
import { headerStyles } from "@insite/content-library/Widgets/OrderApprovalDetails/OrderApprovalDetailsHeader";
import {cartApproverMessageStyles} from "@insite/content-library/Widgets/Common/CartApproverMessage";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";
import { GridOffset } from "@insite/mobius/GridContainer";
import { orderInformationStyles } from "@insite/content-library/Widgets/OrderApprovalDetails/OrderApprovalDetailsOrderInformation";
import { GridItemStyle } from "@insite/mobius/GridItem";
import { orderApprovalDetailsShippingInformationStyles } from "@insite/content-library/Widgets/OrderApprovalDetails/OrderApprovalDetailsShippingInformation";
import { orderConfirmationBillingInformationStyles } from "@insite/content-library/Widgets/OrderApprovalDetails/OrderApprovalDetailsBillingInformation";
import { cartLineCardExpandedStyles } from "@insite/content-library/Components/CartLineCardExpanded";
import { StyledButton } from "@insite/mobius/Clickable";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";

cartLineCardExpandedStyles.productBrandAndDescriptionGridItem = {
    css: css`
        flex-direction: column;
        >${StyledButton}{
            &:hover{
                text-decoration: underline;
            }
            >${TypographyStyle}{
                font-size: 16px;
                color: ${getColor("secondary")};
                font-weight: 500;
            }
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    null,
                    css`
                        min-height: unset;
                    `,
                    null,
                ],
                "max",
            )}
    `,
    width: 12,
}

cartLineCardExpandedStyles.extendedUnitNetPriceGridItem = {
    width: [12, 12, 4, 4, 4],
    css: css`
        flex-direction: column;
        >div[class^="sc"] {
            >${TypographyStyle}{
                color: ${getColor("secondary")};
                &:first-child{
                    font-size: 14px;
                    font-weight: 500;
                }
            }
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        flex-flow: wrap;
                    `,
                ],
                "max",
            )}
    `,
}

cartLineCardExpandedStyles.quantityGridItem = {
    width: [12, 12, 3, 3, 3],
    css: css`
        >div[class^="sc"] {
            >${TypographyStyle}{
                font-size: 14px;
                font-weight: 500;
                color: ${getColor("secondary")};
                &:last-child{
                    font-size: 16px;
                }
            }
        }
    `,
}

cartLineCardExpandedStyles.priceGridItem = {
    width: [12, 12, 5, 5, 5],
    printWidth: 5,
    css: css`
        flex-direction: column;
        >section[class^="sc"] {
            >${TypographyStyle}{
                padding: 0;
                font-size: 14px;
                font-weight: 500;
                color: ${getColor("secondary")};
            }
            >div[class^="sc"] {
                color: ${getColor("secondary")};
            }
        }
    `,
}

cartLineCardExpandedStyles.productPartNumbers = {
    container: {
        css: css`
        >${GridOffset}{
            >${GridItemStyle}{
                >${TypographyStyle}{
                    color: ${getColor("secondary")};
                }
            }
        }
        `
    }
}

cartLineCardExpandedStyles.container = {
    gap: 20,
    css: css`
        border: 1px solid ${getColor("common.border")};
        padding: 0px;
        margin-bottom: 15px;
        > ${GridOffset} {
            width: 100%;
            margin: 0px;
        }
    `,
}

cartLineCardExpandedStyles.productImageGridItem = {
    width: [12, 12, 2, 2, 2],
    printWidth: 1,
    css: css`
        @media print {
            max-height: 83px;
            max-width: 83px;
            padding: 0;
        }
    `,
}

cartLineCardExpandedStyles.orderLineInfoGridItem = {
    width: [12,12,10,10,10],
    printWidth: 11,
}

orderConfirmationBillingInformationStyles.billingInformationBillingAddressGridItem = {
    width: [12, 12, 4, 4, 4],
    printWidth: 4,
    css: css`
        flex-direction: column;
        >address[class^="sc"]{
            p{
                font-size: 16px;
                line-height: 22px;
                color: ${getColor("secondary")};
            }
        }
    `,
}

orderConfirmationBillingInformationStyles.billingAddressTitle = {
    variant: "h6",
    css: css`
        @media print {
            font-size: 12px;
        }
        margin-bottom: 5px;
    `,
}

orderConfirmationBillingInformationStyles.billingCreditCardAddressTitle = {
    variant: "h6",
    css: css`
        @media print {
            font-size: 12px;
        }
        margin-bottom: 5px;
    `,
}

orderConfirmationBillingInformationStyles.billingInformationTitle = {
    variant: "h5",
    css: css`
        @media print {
            font-size: 15px;
        }
        padding-top: 0;
        margin-bottom: 0;
    `,
}

orderApprovalDetailsShippingInformationStyles.shippingInformationTitle = {
    variant: "h5",
    css: css`
        @media print {
            font-size: 15px;
        }
        padding-top: 0;
        margin-bottom: 0;
    `,
}

orderApprovalDetailsShippingInformationStyles.shippingAddressTitle = {
    variant: "h6",
    css: css`
        @media print {
            font-size: 12px;
        }
        margin-bottom: 5px;
    `,
}

orderApprovalDetailsShippingInformationStyles.shippingOtherInformationGridItem = {
    width: [12, 12, 8, 8, 8],
}

orderApprovalDetailsShippingInformationStyles.shippingInformationCarrierGridItem = {
    css: css`
        flex-direction: column;
        > span[class^="TypographyStyle"] {
            color: ${getColor("secondary")};
            font-size: 16px;
        }
    `,
    width: 6,
}

orderApprovalDetailsShippingInformationStyles.shippingCarrierTitle = {
    variant: "h6",
    css: css`
        @media print {
            font-size: 12px;
        }
        margin-bottom: 5px;
    `,
}

orderApprovalDetailsShippingInformationStyles.shippingInformationDateRequestedGridItem = {
    width: 6,
    css: css`
        flex-direction: column;
    `,
}

orderApprovalDetailsShippingInformationStyles.shippingInformationServiceGridItem = {
    css: css`
        flex-direction: column;
    `,
    width: 6,
}

orderApprovalDetailsShippingInformationStyles.shippingServiceTitle = {
    variant: "h6",
    css: css`
        @media print {
            font-size: 12px;
        }
        margin-bottom: 5px;
    `,
}

orderApprovalDetailsShippingInformationStyles.shippingServiceText = {
    css: css`
        color: ${getColor("secondary")};
    `
}

orderApprovalDetailsShippingInformationStyles.shippingDateRequestedTitle = {
    variant: "h6",
    css: css`
        @media print {
            font-size: 12px;
        }
        margin-bottom: 5px;
    `,
}

orderApprovalDetailsShippingInformationStyles.shippingInformationAddressGridItem = {
    width: [12, 12, 4, 4, 4],
    css: css`
        flex-direction: column;
        >address[class^="sc"]{
            p{
                font-size: 16px;
                line-height: 22px;
                color: ${getColor("secondary")};
            }
        }
    `,
}

orderInformationStyles.orderInformationGridContainer = {
    gap: 15,
    css: css`
    >${GridOffset}{
        width: 100%;
        margin: 0px;
    }
    `
}

orderInformationStyles.shippingInformationGridItem = {
    width: 12,
    css: css`
    padding-left: 0px;
    `
}

orderInformationStyles.billingInformationGridItem = {
    width: 12,
    css: css`
    padding-left: 0px;
    `
}

orderInformationStyles.mainInformationGridItem = {
    width: 12,
    css: css`
    padding: 7.5px 0px 25px;
    `
}

orderInformationStyles.orderNumberGridItem = {
    width: [6, 6, 3, 3, 3],
    css: css`
        flex-direction: column;
    `,
}

orderInformationStyles.orderDateGridItem = {
    width: [6, 6, 3, 3, 3],
    css: css`
        flex-direction: column;
    `,
}

orderInformationStyles.poNumberGridItem = {
    width: [6, 6, 3, 3, 3],
    css: css`
        flex-direction: column;
    `,
}

orderInformationStyles.statusGridItem = {
    width: [6, 6, 3, 3, 3],
    css: css`
        padding-left: 0px;
        flex-direction: column;
    `,
}

orderInformationStyles.orderNumberTitle = {
    variant: "h6",
    css: css`
        @media print {
            font-size: 12px;
        }
        margin-bottom: 5px;
    `,
}

orderInformationStyles.orderDateTitle = {
    variant: "h6",
    css: css`
        @media print {
            font-size: 12px;
        }
        margin-bottom: 5px;
    `,
}

orderInformationStyles.poNumberTitle = {
    variant: "h6",
    css: css`
        @media print {
            font-size: 12px;
        }
        margin-bottom: 5px;
    `,
}

orderInformationStyles.notesGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
        padding-left: 0px;
    `,
}

orderInformationStyles.notesTitle = {
    variant: "h6",
    css: css`
        margin-bottom: 5px;
    `,
}

orderInformationStyles.notesDescription = {
    css: css`
    color: ${getColor("secondary")};
    font-size: 16px;
    `
}

orderInformationStyles.statusTitle = {
    variant: "h6",
    css: css`
        @media print {
            font-size: 12px;
        }
        margin-bottom: 5px;
    `,
}



orderInformationStyles.mainInformationGridContainer = {
    css: css`
    ${GridOffset}{
        >${GridItemStyle}{
            padding-top: 8px;
            > span[class^="TypographyStyle"] {
                color: ${getColor("secondary")};
            }
        }
    }
    `
}

cartApproverMessageStyles.approvingWrapper = {
    css: css`
        text-align: center;
        padding: 10px;
        background-color: ${getColor("info.contrast")};
    `,
}

cartApproverMessageStyles.approvingText = {
    css: css`
        width: 100%;
        color: ${getColor("secondary")};
        font-weight: bold;
    `,
}

headerStyles.title = {
    variant: "h1",
    css: css`
        @media print {
            font-size: 11px;
        }
    `,
}

orderApprovalDetailsActionButtonsStyles.buttonsHiddenContainer = {
    below: "lg",
}

orderApprovalDetailsActionButtonsStyles.printClickable = {
    css: css`
    color: ${getColor("secondary")};
    `
}

orderApprovalDetailsActionButtonsStyles.deleteClickable = {
    css: css`
    color: ${getColor("secondary")};
    `
}

orderApprovalDetailsActionButtonsStyles.approveClickable = {
    css: css`
    color: ${getColor("secondary")};
    `
}

orderApprovalDetailsActionButtonsStyles.continueShoppingClickable = {
    css: css`
    color: ${getColor("secondary")};
    `
}

orderApprovalDetailsActionButtonsStyles.continueShoppingButton = {
    css: css`
        margin-left: 10px;
    `,
}

orderApprovalDetailsActionButtonsStyles.deleteButton = {
    css: css`
        margin-left: 10px;
    `,
    buttonType: "outline",
    variant: "secondary",
}

orderApprovalDetailsActionButtonsStyles.printButton = {
    variant: "secondary",
    buttonType: "outline",
}